import { TemplatesStore } from './templates-store';

export default class TemplatesRootStore {
	templatesStore: TemplatesStore;

	init() {
		this.templatesStore = new TemplatesStore();
	}
}
